import React, { useContext, useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { c as classnames } from './index-2586sEvh.js';
import { g as gsapWithCSS } from './index-RkBJ48Nr.js';
import { S as ScrollTriggerExports } from './animations--PMkOS0j.js';
import { N as NavigationMenu } from './NavigationMenu-JWp5GMi2.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import './index-dEXHnASi.js';
import 'notistack';
import 'next-i18next';
import useWindowSize from './hooks/useWindowSize.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-qU2Vf3ni.js';
import 'lodash';
import { L as Logo } from './Logo-fy1HhiD6.js';
import { A as ActionBar } from './ActionBar-_-_7UhKr.js';
import { S as SkipNavigation } from './SkipNavigation-wioCm4mt.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { C as ConditionalWrapper } from './ConditionalWrapper-6zYfwfM_.js';

const Header = ({ navMenu, showActions, onAction, mobileHide, breakNav, rightNav, blockNavChildren, transparent, sticky, disableStyckyAnimation, animateElements, iconOrder, }) => {
    const { data: { siteConfig: { LOGO_IMAGE }, }, } = useContext(CoreContext);
    const windowSize = useWindowSize();
    const { locale, pathname } = useRouter();
    const [isCheckout, setIsCheckout] = useState(pathname.includes('checkout'));
    const headerRef = useRef();
    const wrapRef = useRef();
    const logoRef = useRef();
    const navRef = useRef();
    const utilitiesRef = useRef();
    const [headerHeight, setHeight] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    const isBreakNav = () => !!(breakNav > windowSize.width || breakNav === 'always');
    useEffect(() => {
        setIsCheckout(pathname.includes('checkout'));
    }, [pathname]);
    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const { abIcon = true } = animateElements || {};
    useEffect(() => {
        if (disableStyckyAnimation) {
            return () => { };
        }
        const ctx = gsapWithCSS.context(() => {
            gsapWithCSS.registerPlugin(ScrollTriggerExports.ScrollTrigger);
            const topBanner = document.querySelector('header .top-banner') || null;
            const topBannerText = document.querySelector('header .top-banner a p') || null;
            const animTrigger = {
                trigger: 'header',
                start: 1,
                end: 1,
                toggleActions: 'play none reverse none',
                pin: false,
            };
            const animDuration = 0.2;
            ScrollTriggerExports.ScrollTrigger.matchMedia({
                '(min-width: 1025px)': () => {
                    var _a, _b;
                    gsapWithCSS.timeline({ scrollTrigger: animTrigger }).fromTo('header', {
                        paddingTop: 15,
                        paddingBottom: 15,
                        ...(transparent && { boxShadow: '0px 8px 5px -9px rgba(0, 0, 0, 0)' }),
                        onComplete: setHeight,
                        onCompleteParams: [(_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight],
                    }, {
                        paddingTop: 5,
                        paddingBottom: 5,
                        ...(transparent && { boxShadow: '0px 8px 5px -9px rgba(0, 0, 0, 0.36)' }),
                        ease: 'sine.inOut',
                        duration: animDuration,
                    });
                    if (abIcon) {
                        gsapWithCSS
                            .timeline({ scrollTrigger: animTrigger })
                            .to('.ab-icon', { fontSize: 33, ease: 'sine.inOut', duration: animDuration });
                    }
                    gsapWithCSS.timeline({ scrollTrigger: animTrigger }).to('.main-logo a', {
                        height: 50,
                        marginBottom: 0,
                        ease: 'sine.inOut',
                        duration: animDuration,
                    });
                    gsapWithCSS.timeline({ scrollTrigger: animTrigger }).to('.utilities', {
                        gap: 20,
                        ease: 'sine.inOut',
                        duration: animDuration,
                    });
                    setHeight((_b = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight);
                },
                '(max-width: 1024px)': () => {
                    var _a;
                    if (mobileHide) {
                        const headerHide = gsapWithCSS
                            .from('header', {
                            top: -100,
                            paused: true,
                            duration: animDuration,
                        })
                            .progress(1);
                        ScrollTriggerExports.ScrollTrigger.create({
                            start: 'top top',
                            end: 99999,
                            onUpdate: self => {
                                if (self.direction === -1)
                                    headerHide.play();
                                else
                                    headerHide.reverse();
                            },
                        });
                    }
                    setHeight((_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
                    gsapWithCSS.set('.ab-icon', { clearProps: 'fontSize' });
                    gsapWithCSS.set('header', { clearProps: 'all' });
                    gsapWithCSS.set('.utilities', { clearProps: 'all' });
                },
                '(min-width: 320px)': () => {
                    if (topBannerText) {
                        gsapWithCSS
                            .timeline({ scrollTrigger: animTrigger })
                            .to(topBanner, { duration: animDuration, padding: 0, marginBottom: 0 });
                        gsapWithCSS
                            .timeline({ scrollTrigger: animTrigger })
                            .set(topBannerText, { opacity: 1 })
                            .to(topBannerText, { duration: animDuration, opacity: 0 })
                            .to(topBannerText, { duration: animDuration, fontSize: 0 });
                    }
                },
            });
        }, headerRef);
        if (!sticky || isCheckout) {
            ctx.revert();
        }
        return () => ctx.revert();
    }, [headerHeight, isCheckout]);
    return (React.createElement(React.Fragment, null,
        !isCheckout && React.createElement(SkipNavigation, null),
        React.createElement("header", { id: "header", className: classnames({
                transparent,
                scrolled: scrolled && !isCheckout,
                'header-sticky': sticky && !isCheckout,
            }), ref: headerRef },
            React.createElement("div", { ref: wrapRef, className: classnames('header-wrap', {
                    'break-nav': isBreakNav(),
                    'break-nav-auto': breakNav === 'auto',
                    'right-nav': rightNav,
                    'block-nav-children': blockNavChildren,
                }) },
                React.createElement(Logo, { url: `/${locale}`, img: LOGO_IMAGE, ref: logoRef }),
                React.createElement(ConditionalWrapper, { condition: breakNav === 'auto', wrapper: React.createElement("div", { className: "right-wrap" }) },
                    React.createElement(React.Fragment, null,
                        showActions && !isCheckout && React.createElement(NavigationMenu, { ref: navRef, menu: navMenu }),
                        showActions && (React.createElement(ActionBar, { ref: utilitiesRef, isCheckout: isCheckout, onAction: onAction, iconOrder: iconOrder }))))))));
};
var Header$1 = withProviders(Header, { translation: true });

export { Header$1 as H };
//# sourceMappingURL=Header-eYLfi8hl.js.map
